<template>
  <base-card :loading="isAllPending">
    <template v-slot:body-top>
      <base-card-title>Your Portfolio</base-card-title>
    </template>
    <template v-if="investments.length">
      <div v-for="(investment, key) in investments" :key="key" class="portfolio">
        <div class="row align-items-center">
          <div class="col-sm-3 mb-3 mb-sm-0">
            <router-link class="font-weight-semibold" :to="$investment.getRoute(investment.investment)">
              {{ investment.investment.title }}
              {{ investment.investment.investmentType === 'Portfolio' ? 'Portfolio' : '' }}
            </router-link>
            <div class="label">
              {{ $investment.getInvestmentType(investment.investment) }}
            </div>
          </div>
          <div class="col-sm-9">
            <div class="row">
              <div class="col-6 mb-2 text-sm-right">
                <div class="label">
                  Invested
                </div>
                <div class="font-weight-semibold">
                  {{ $formatting.toCurrency(investment.invested) }}
                </div>
              </div>
              <div class="col-6 mb-2 text-sm-right">
                <div class="label">
                  Share Price
                </div>
                <div class="font-weight-semibold">
                  {{ $formatting.toCurrency(investment.investment.costPerShare) }}
                </div>
              </div>
              <div class="col-6 text-sm-right">
                <div class="label">
                  <template v-if="['Portfolio', 'PrivateEquity'].includes(investment.investment.investmentType)">
                    Returns
                  </template>
                  <template v-else>
                    Interest Rate
                  </template>
                </div>
                <div class="font-weight-semibold">
                  <template v-if="['Portfolio', 'PrivateEquity'].includes(investment.investment.investmentType)">
                    {{ investment.investment.dividend }}% p.a.
                  </template>
                  <template v-else>
                    {{ investment.investment.funding ? investment.investment.funding.interestRate : investment.investment.rounds[0].interestRate }}% p.a.
                  </template>
                </div>
              </div>
              <div class="col-6 text-sm-right">
                <div class="label">
                  Repayment Date
                </div>
                <div class="font-weight-semibold">
                  {{ $dates.toDate(investment.investment.repaymentDate) || 'n/a' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <p>
        You haven't made any investments yet.
      </p>
    </template>
  </base-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'UserPortfolio',

  created () {
    this.getInvestments()
  },

  computed: {
    ...mapState({
      investments: store => store.core.userInvestments.all,
      isAllPending: store => store.core.userInvestments.isAllPending
    })
  },

  methods: {
    ...mapActions({
      getInvestments: 'core/user-investments/all'
    })
  }
}
</script>
